import {transient} from "aurelia-framework";
import {BaseRuleConfigPlugin} from "./base-rule-config-plugin";

@transient()
export class RequireCfrReview extends BaseRuleConfigPlugin {


}